import { useState } from 'react'

import { useHistory } from "react-router-dom";

import { TemplateServiceApi } from "../../service/api/TemplateServiceApi";

const hierarchyArray = ["question", "ambito", "requisito", "principio", "fatQual"]; // in this order so that for example fatQual > requisito

const useTemplateMonitorLogic = () => {
  // A LOT OF CODE HAS BEEN COMMENTED OUT THAT IS RELATED TO QUANTITATIVE QUESTIONS WHICH IS KEPT IN CASE IT IS NEEDED FOR FUTURE USE

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  // const [opScopes, setOpScopes] = useState([]);
  const [originalData, setOriginalData] = useState(); // will be used on save/evaluate
  const [finalData, setFinalData] = useState([]);
  const [areAttributesShown, setAreAttributesShown] = useState(true);
  const [allControlFunctions, setAllControlFunctions] = useState([]);
  const [selectedControlFunctionId, setSelectedControlFunctionId] = useState(0);
  const [selectedOpScopes, setSelectedOpScopes] = useState([]);

  // Generic Modal
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  const initialConfiguration = (controlFunctionsApiRes, fattoriQualificanti) => {

    // Keeping the control functions that are active
    const contFunctions = controlFunctionsApiRes.filter(cf => cf.active === true);

    setAllControlFunctions(contFunctions)

    // HERE THE SORTING OF ALL THE ARRAYS IS TAKING PLACE
    fattoriQualificanti.sort((a, b) => a.position > b.position ? 1 : -1);
    for (let fatQual of fattoriQualificanti) {
      fatQual.templateCosoPrincipi.sort((a, b) => a.position > b.position ? 1 : -1);
      for (let principio of fatQual.templateCosoPrincipi) {
        principio.templateCosoRequisiti.sort((a, b) => a.position > b.position ? 1 : -1);
        for (let requisito of principio.templateCosoRequisiti) {
          requisito.templateCosoAmbiti.sort((a, b) => a.position > b.position ? 1 : -1);
          for (let ambito of requisito.templateCosoAmbiti) {
            if (ambito.templateQualitativeQuestions.length > 0) {
              ambito.templateQualitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
              for (let question of ambito.templateQualitativeQuestions) {
                question.templateQualitativeQuestionControlFunctionOperationalScopes
                  .sort((a, b) => a.controlFunction.id > b.controlFunction.id ? 1 : -1)
                // the sorting above is not necessary since the CFOS data are saved in a sorted way in createQuestionObject()
              }

              for (let question of ambito.templateQuantitativeQuestions) {
                question.templateQuantitativeQuestionControlFunctionOperationalScopes
                  .sort((a, b) => a.controlFunction.id > b.controlFunction.id ? 1 : -1)
              }
            }
            // if (ambito.templateQuantitativeQuestions.length > 0) {
            //   ambito.templateQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            //   for (let question of ambito.templateQuantitativeQuestions) {
            //     question.templateQualitativeQuestionControlFunctionOperationalScopes
            //       .sort((a, b) => a.controlFunction.id > b.controlFunction.id ? 1 : -1)
            //   }
            // }
            // QUANTITATIVE DRIVERS (not included in template monitor for now)
            // if (ambito.templateQuantitativeDrivers.length > 0) {
            //   ambito.templateQuantitativeDrivers.sort((a, b) => a.id > b.id ? 1 : -1);
            //   for (let templateQuantitativeDriver of ambito.templateQuantitativeDrivers) {
            //     templateQuantitativeDriver.templateQuantitativeQuestions.sort((a, b) => a.position > b.position ? 1 : -1);
            //   }
            // }
          }
        }
      }
    }

    setOriginalData(fattoriQualificanti);

    let mainData = [];
    for (let fatQual of fattoriQualificanti) {
      // const osFatQual = Array(initialOpScopes.length).fill(false); 
      mainData.push(createDataObject(fatQual, "fatQual", contFunctions)); // id, position(?probably not needed) title, type, operationalScopes values
      for (let principio of fatQual.templateCosoPrincipi) {
        mainData.push(createDataObject(principio, "principio", contFunctions));
        for (let requisito of principio.templateCosoRequisiti) {
          mainData.push(createDataObject(requisito, "requisito", contFunctions));
          for (let ambito of requisito.templateCosoAmbiti) {
            mainData.push(createDataObject(ambito, "ambito", contFunctions));
            if (ambito.templateQualitativeQuestions.length > 0) {
              for (let question of ambito.templateQualitativeQuestions) {
                mainData.push(createQuestionObject(question, fatQual.id, principio.id, requisito.id, ambito.id, ambito.isQualitative, ambito.active, contFunctions));
              }
            }
            if (ambito.templateQuantitativeQuestions?.length > 0) {
              for (let question of ambito.templateQuantitativeQuestions) {
                mainData.push(createQuantativeQuestionObject(question, fatQual.id, principio.id, requisito.id, ambito.id, ambito.isQualitative, ambito.active, ambito.poor, ambito.good, ambito.unsatisfactory, contFunctions));
              }
            }
          }
        }
      }
    }

    // In this block we are applying flags to all elements that are not questions based on the default flags of all the questions
    // fatQual "span" property will determine the number of rows that this title will expand to
    let count = 0;
    for (let i = mainData.length - 1; i >= 0; i--) {
      const arrayEl = mainData[i];
      // length of each fattore qualificante
      if (arrayEl.type && arrayEl.type === "fatQual") {
        arrayEl.span = count;
        count = 0; // reset the counter for the next 
      } else {
        count++;
      }
      if (!arrayEl.type) {
        for (const [cFunctionId, opScopesArray] of Object.entries(arrayEl.conFuncOpScopes)) {
          for (const [index, opScope] of opScopesArray.entries()) {
            if (opScope.enabled === true) {
              let hierarchyThreshold = 0;
              for (let j = i - 1; j >= 0; j--) {
                const el = mainData[j];
                if (el.type) {
                  let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
                  if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element in the table, thus we stop the iteration
                    el.conFuncOpScopes[cFunctionId][index].enabled = true; // the index helps us select the corresponding opScope in all other opScopes arrays of the elements that we need to modify
                    // el.operationalScopes[opScope] = true;
                    break;
                  }
                  else if (currentElementHierarchyLevel > hierarchyThreshold) {
                    el.conFuncOpScopes[cFunctionId][index].enabled = true;
                    hierarchyThreshold++;
                  } else continue;
                }
              }
            }
          }
        }
      }
    }

    setFinalData([...mainData]);
    setIsLoading(false);
  }

  const createDataObject = ({ id, title, tooltip, isQualitative, isDeletable, active, poor, good, unsatisfactory, templateQuantitativeQuestions, templateQualitativeQuestions, position }, givenType, cFunctions) => {
    const conFuncOpScopes = {};
    for (let cf of cFunctions) {
      conFuncOpScopes[cf.id] = [...cFunctions.filter(conF => conF.id === cf.id)[0].operationalScopes.map(el => {
        return {
          id: el.id,
          name: el.name,
          enabled: false
        }
      })];
    }

    const dataObject = {
      id,
      title,
      ...(tooltip !== undefined && { tooltip }),
      type: givenType,
      conFuncOpScopes,
      isHidden: false,
      isCollapsed: false,
      hasValidChildren: true,
      invalidInputs: { qntAmbitoHasInvalidQuestionsLength: false, qntAmbitoHasNoKpis: false },
    }

    if (dataObject.type === "ambito") {
      dataObject.isQualitative = isQualitative;
      dataObject.isDeletable = isDeletable;
      dataObject.active = active;
      dataObject.poor = poor || 0;
      dataObject.good = good || 0;
      dataObject.unsatisfactory = unsatisfactory || 0;
      dataObject.templateQuantitativeQuestions = templateQuantitativeQuestions;
      dataObject.templateQualitativeQuestions = templateQualitativeQuestions;
      dataObject.position = position;
    }

    return dataObject;
  }

  const createQuantativeQuestionObject = (
    {
      id,
      position,
      question,
      displayId,
      templateQuantitativeQuestionControlFunctionOperationalScopes,
    },
    fatQualId,
    principioId,
    requisitoId,
    ambitoId,
    isQualitative,
    active,
    poor,
    good,
    unsatisfactory,
    cFunctions
  ) => {
    const originalCFOSs = [
      ...templateQuantitativeQuestionControlFunctionOperationalScopes,
    ];

    const conFuncOpScopes = {};
    for (let cf of cFunctions) {
      conFuncOpScopes[cf.id] = [
        ...cFunctions
          .filter((conF) => conF.id === cf.id)[0]
          .operationalScopes.map((el) => {
            return {
              id: el.id,
              name: el.name,
              // position:el.position,
              enabled: false,
            };
          }),
      ];
    }

    for (let el of originalCFOSs) {
      // ignore control functions that are inactive
      if (!el.controlFunction.active) {
        continue;
      }

      let cfid = el.controlFunction.id;
      let matchingOpScope = conFuncOpScopes[cfid].find(
        (os) => os.id === el.operationalScope.id
      );
      if (matchingOpScope) {
        matchingOpScope.enabled = true;
      }
    }

    // 'Completezza' -> 'Completeness'
    // 'Adeguatezza' -> 'Accuracy'
    // 'Funzionalita' -> 'Effectiveness'
    // 'Affidabilita' -> 'Reliability'

    const attributesDrivers = [
      {
        value: poor !== null && poor !== undefined ? poor : 0,
        name: "Poor",
        disabled: true,
      },
      {
        value: good !== null && good !== undefined ? good : 0,
        name: "Good",
        disabled: true,
      },
      {
        value: unsatisfactory !== null && unsatisfactory !== undefined ? unsatisfactory : 0,
        name: "Unsatisfactory",
        disabled: true,
      }
    ];

    const invalidInputs = {
      mainAttributeIsUndefined: false,
      allAttrDriversAreUnckecked: false,
      questionTitleIsEmpty: false,
      allOpAreasAreUnchecked: false,
    };

    return {
      templateQuantitativeQuestionControlFunctionOperationalScopes,
      conFuncOpScopes: conFuncOpScopes,
      position: position,
      title: question,
      displayId: displayId,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId: id,
      invalidInputs: invalidInputs,
      isHidden: false,
      tooltip: null,
      isQualitative,
      active,
      attributesDrivers: attributesDrivers,
    };
  };

  const createQuestionObject = (
    {
      templateQualitativeQuestionControlFunctionOperationalScopes,
      driverCompletezza,
      driverAdeguatezza,
      driverFunzionalita,
      driverAffidabilita,
      id,
      position,
      question,
      supervisedEntity,
      notSupervisedEntity,
      headCompany,
      operativeCompany,
      foreign,
      italy,
      tooltip,
      displayId
    },
    fatQualId,
    principioId,
    requisitoId,
    ambitoId,
    isQualitative,
    active,
    cFunctions
  ) => {
    const originalCFOSs = [
      ...templateQualitativeQuestionControlFunctionOperationalScopes,
    ];

    const conFuncOpScopes = {};
    for (let cf of cFunctions) {
      conFuncOpScopes[cf.id] = [
        ...cFunctions
          .filter((conF) => conF.id === cf.id)[0]
          .operationalScopes.map((el) => {
            return {
              id: el.id,
              name: el.name,
              // position:el.position,
              enabled: false,
            };
          }),
      ];
    }

    for (let el of originalCFOSs) {
      // ignore control functions that are inactive
      if (!el.controlFunction.active) {
        continue;
      }

      let cfid = el.controlFunction.id;
      let matchingOpScope = conFuncOpScopes[cfid].find(
        (os) => os.id === el.operationalScope.id
      );
      if (matchingOpScope) {
        matchingOpScope.enabled = true;
      }
    }

    const mainAttributes = [
      {
        value: (supervisedEntity === null || supervisedEntity === undefined) ? null : supervisedEntity,
        name: "supervisedEntity",
        label: "Supervised Entity",
        shortName: "SE"
      },
      {
        value: (notSupervisedEntity === null || notSupervisedEntity === undefined) ? null : notSupervisedEntity,
        name: "notSupervisedEntity",
        label: "Not Supervised Entity",
        shortName: "N_SE"
      },
      {
        value: (headCompany === null || headCompany === undefined) ? null : headCompany,
        name: "isHeadCompany",
        label: "Holding",
        shortName: "HOLD"
      },
      {
        value: (operativeCompany === null || operativeCompany === undefined) ? null : operativeCompany,
        name: "isOperativeCompany",
        label: "Operating Legal Entity",
        shortName: "OP_COMP"
      },
      {
        value: (foreign === null || foreign === undefined) ? null : foreign,
        name: "isForeign",
        label: "Other Region",
        shortName: "OTH_REG"
      },
      {
        value: (italy === null || italy === undefined) ? null : italy,
        name: "isItaly",
        label: "Region Italy",
        shortName: "REG_ITA"
      },
    ]

    // 'Completezza' -> 'Completeness'
    // 'Adeguatezza' -> 'Accuracy'
    // 'Funzionalita' -> 'Effectiveness'
    // 'Affidabilita' -> 'Reliability'

    const attributesDrivers = [
      {
        value:
          driverCompletezza !== null &&
            driverCompletezza !== undefined
            ? driverCompletezza
            : 0,
        name: "Completeness",
      },
      {
        value:
          driverAdeguatezza !== null &&
            driverAdeguatezza !== undefined
            ? driverAdeguatezza
            : 0,
        name: "Accuracy",
      },
      {
        value:
          driverFunzionalita !== null &&
            driverFunzionalita !== undefined
            ? driverFunzionalita
            : 0,
        name: "Effectiveness",
      },
      {
        value:
          driverAffidabilita !== null &&
            driverAffidabilita !== undefined
            ? driverAffidabilita
            : 0,
        name: "Reliability",
      }
    ];

    // new feature for displaying invalid input fields
    const invalidInputs = {
      mainAttributeIsUndefined: false,
      allAttrDriversAreUnckecked: false,
      questionTitleIsEmpty: false,
      allOpAreasAreUnchecked: false,
    };

    return {
      templateQualitativeQuestionControlFunctionOperationalScopes,
      conFuncOpScopes: conFuncOpScopes,
      position: position,
      title: question,
      tooltip: tooltip,
      displayId: displayId,
      mainAttributes,
      attributesDrivers: attributesDrivers,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      questionId: id,
      invalidInputs: invalidInputs,
      isHidden: false,
      isQualitative,
      active
    };
  };

  // This function is called when the clicked element was a question
  const updateOriginalData = (record, data, operationType, updates) => {
    let procedureCompleted = false;
    for (let fatQual of data) {
      for (let principio of fatQual.templateCosoPrincipi) {
        if (record.principioId === principio.id)
          for (let requisito of principio.templateCosoRequisiti) {
            if (record.requisitoId === requisito.id)
              // Here we need to create new Ambito
              if (operationType === "addingAmbito") {
                requisito.templateCosoAmbiti.push(updates.newAmbito);
                return;
              }
            for (let ambito of requisito.templateCosoAmbiti) {
              if (record.ambitoId === ambito.id) {
                if (operationType === "changeQntDriver") {
                  ambito[updates.driver.name] = +updates.driver.value;
                  return;
                }
                if (operationType === "togglingAmbito") {
                  ambito.active = record.active;
                  return;
                }

                if (operationType === "updatingAmbitoTitle") {
                  ambito.title = updates.newTitle;
                  return;
                }

                if (operationType === "removingAmbito") {
                  requisito.templateCosoAmbiti = requisito.templateCosoAmbiti.filter(amb => amb.id !== record.ambitoId);
                  return;
                }

                if (operationType === "checkingQntOpScope") {
                  ambito.templateQuantitativeQuestions.forEach(q => {
                    q.templateQuantitativeQuestionControlFunctionOperationalScopes.push(record.conFuncOpScopes);
                  });
                  return;
                }

                if (operationType === "uncheckingQntOpScope") {
                  let indexToBeRemoved = -1;
                  ambito.templateQuantitativeQuestions.forEach(q => {
                    const conFuncOpScopes = q.templateQuantitativeQuestionControlFunctionOperationalScopes;
                    indexToBeRemoved = conFuncOpScopes.findIndex(cfos => {
                      return cfos.controlFunction.id === updates.cfosIds.cfId && cfos.operationalScope.id === updates.cfosIds.osId;
                    });
                  });
                  ambito.templateQuantitativeQuestions.forEach(q => {
                    const filtered = q.templateQuantitativeQuestionControlFunctionOperationalScopes.filter((_, idx) => idx !== indexToBeRemoved);
                    q.templateQuantitativeQuestionControlFunctionOperationalScopes = filtered;
                  });
                  return;
                }

                let questionIndex = 0;
                if (record.position === 0) {
                  // in this case, an ambito Add button was clicked ("operationType === addingQuestion"), that is the reason we pass position 0
                  updatingDataOperations(0, undefined, operationType, ambito.templateQualitativeQuestions, updates);
                } else {
                  for (const [qIndex, question] of ambito.templateQualitativeQuestions.entries()) {
                    if (question.position === record.position) {
                      questionIndex = qIndex;
                      updatingDataOperations(record.position, question, operationType, ambito.templateQualitativeQuestions, updates);
                      if (
                        operationType === "updateMainAttribute" ||
                        operationType === "changeDriver" ||
                        operationType === "checkingOpScope" ||
                        operationType === "uncheckingOpScope" ||
                        operationType === "updatingTitle" ||
                        operationType === "updatingTooltip"
                      ) {
                        // procedureCompleted = true;
                        return;
                      }
                      break;
                    }
                  }

                  for (const [qIndex, question] of ambito.templateQuantitativeQuestions.entries()) {
                    if (question.position === record.position) {
                      questionIndex = qIndex;
                      updatingDataOperations(record.position, question, operationType, ambito.templateQualitativeQuestions, updates);
                      if (
                        operationType === "updateMainAttribute" ||
                        operationType === "changeDriver" ||
                        operationType === "checkingOpScope" ||
                        operationType === "uncheckingOpScope" ||
                        operationType === "updatingTitle" ||
                        operationType === "updatingTooltip"
                      ) {
                        // procedureCompleted = true;
                        return;
                      }
                      break;
                    }
                  }
                }
                if (!procedureCompleted) {
                  // in case of adding/removing a question
                  let startingElIndex = 0;
                  if (record.position === 0) {
                    startingElIndex = 1;
                  } else {
                    startingElIndex = questionIndex + 2;
                  }
                  if (operationType === "addingQuestion" && startingElIndex < ambito.templateQualitativeQuestions.length) {
                    for (let i = startingElIndex; i < ambito.templateQualitativeQuestions.length;
                      i++
                    ) {
                      ambito.templateQualitativeQuestions[i].position++;
                    }
                  } else if (operationType === "removingQuestion") {
                    for (
                      let i = questionIndex;
                      i < ambito.templateQualitativeQuestions.length;
                      i++
                    ) {
                      ambito.templateQualitativeQuestions[i].position--;
                    }
                  }
                }
                // }
                // else {
                //   for (let templateQuantitativeDriver of ambito.templateQuantitativeDrivers) {
                //     for (const question of templateQuantitativeDriver.templateQuantitativeQuestions) {
                //       if (question.position === record.position) {
                //         updatingDataOperations(record.position, question, operationType, templateQuantitativeDriver.templateQuantitativeQuestions, opScope, newQuestion, newTitle);
                //       }
                //     }
                //   }
                // }
              }
              // if (procedureCompleted) break;
            }
            // if (procedureCompleted) break;
          }
        // if (procedureCompleted) break;
      }
      // if (procedureCompleted) break;
    }
  };

  // triggered when the element that was changed directly was principio/ requisito/ ambito
  // Explanation: We search for the element that was clicked by the id and the type. Once found, we update all the questions that belong to this element. Once this process is complete we terminate the function.
  const higherHierarchyElementsHandler = (record, data, operationType, updates) => {
    let elementFound = false;
    let operationComplete = false;
    for (let fatQual of data) {
      for (let principio of fatQual.templateCosoPrincipi) {
        if (record.id === principio.id && record.type === "principio") {
          if (operationType === "updatingTooltip") {
            updatingDataOperations(undefined, principio, operationType, undefined, updates);
            return;
          }
          elementFound = true;
        }
        for (let requisito of principio.templateCosoRequisiti) {
          if (record.id === requisito.id && record.type === "requisito") {
            if (operationType === "updatingTooltip") {
              updatingDataOperations(undefined, requisito, operationType, undefined, updates);
              return;
            }
            elementFound = true;
          }
          for (let ambito of requisito.templateCosoAmbiti) {
            if (record.id === ambito.id && record.type === "ambito") {
              if (operationType === "updatingTooltip") {
                updatingDataOperations(undefined, ambito, operationType, undefined, updates);
                return;
              }
              elementFound = true;
            }
            if (elementFound) {
              if (ambito.templateQualitativeQuestions.length > 0) {
                for (const question of ambito.templateQualitativeQuestions) {
                  updatingDataOperations(record.position, question, operationType, ambito.templateQualitativeQuestions, updates);
                }
              }
              // if (ambito.templateQuantitativeDrivers.length > 0) {
              //   for (let templateQuantitativeDriver of ambito.templateQuantitativeDrivers) {
              //     for (const question of templateQuantitativeDriver.templateQuantitativeQuestions) {
              //       updatingDataOperations( record.position, question, operationType, templateQuantitativeDriver.templateQuantitativeQuestions, updates);
              //     }
              //   }
              // }
            }
            if (elementFound && record.type === "ambito") {
              return;
              // operationComplete = true;
              // break;
            }
          }
          if ((elementFound && record.type === "requisito") /* || operationComplete */) {
            return;
            // operationComplete = true;
            // break;
          }
        }
        if ((elementFound && record.type === "principio") /*|| operationComplete */) {
          return;
          // break;
        }
      }
      // if (elementFound) {
      //   break;
      // }
    }
  };

  const updatingDataOperations = (position, element, operationType, questionsArray, updates) => {

    const {
      mainAttribute,
      driver,
      cfosIds,
      newQuestion,
      newTitle,
      updatedTooltip
    } = updates;
    let questionIndex;
    switch (operationType) {
      case "updateMainAttribute":
        switch (mainAttribute.name) {
          case 'supervisedEntity':
            element.supervisedEntity = mainAttribute.value;
            break;
          case 'notSupervisedEntity':
            element.notSupervisedEntity = mainAttribute.value;
            break;
          case 'isHeadCompany':
            element.headCompany = mainAttribute.value;
            break;
          case 'isOperativeCompany':
            element.operativeCompany = mainAttribute.value;
            break;
          case 'isForeign':
            element.foreign = mainAttribute.value;
            break;
          case 'isItaly':
            element.italy = mainAttribute.value;
            break;
          default:
            break;
        }
        break;
      case "changeDriver":
        // 'Completezza' -> 'Completeness'
        // 'Adeguatezza' -> 'Accuracy'
        // 'Funzionalita' -> 'Effectiveness'
        // 'Affidabilita' -> 'Reliability'

        switch (driver.name) {
          case 'Completeness':
            element.driverCompletezza = driver.value;
            break;
          case 'Accuracy':
            element.driverAdeguatezza = driver.value;
            break;
          case 'Effectiveness':
            element.driverFunzionalita = driver.value;
            break;
          case 'Reliability':
            element.driverAffidabilita = driver.value;
            break;
          case 'Poor':
            element.poor = driver.value;
            break;
          case 'Good':
            element.good = driver.value;
            break;
          case 'Unsatisfactory':
            element.unsatisfactory = driver.value;
            break;
          default:
            break;
        }
        break;
      case "checkingOpScope":
        element.templateQualitativeQuestionControlFunctionOperationalScopes.push(createCFOSinOriginalForm(cfosIds.cfId, cfosIds.osId));
        break;
      case "uncheckingOpScope":
        let indexOfElementToBeRemoved;
        indexOfElementToBeRemoved = element.templateQualitativeQuestionControlFunctionOperationalScopes.findIndex(
          el => (
            el.controlFunction.id === cfosIds.cfId && el.operationalScope.id === cfosIds.osId
          )
        );
        if (indexOfElementToBeRemoved > -1) {
          element.isQualitative ? element.templateQualitativeQuestionControlFunctionOperationalScopes.splice(indexOfElementToBeRemoved, 1) : element.templateQuantitativeQuestionControlFunctionOperationalScopes.splice(indexOfElementToBeRemoved, 1);
        }
        // if (question && question.hasOwnProperty("templateQualitativeQuestionOperationalScopes")) {
        //   for (const scope of question.templateQualitativeQuestionOperationalScopes) {
        //     if (scope.operationalScope.name === opScope) {
        //       scope.enabled = false;
        //       break;
        //     }
        //   }
        // } else {
        //   for (const scope of question.templateQuantitativeQuestionOperationalScopes) {
        //     if (scope.operationalScope.name === opScope) {
        //       scope.enabled = false;
        //       break;
        //     }
        //   }
        // }
        break;
      case "addingQuestion":
        if (position !== 0) {
          questionIndex = questionsArray.findIndex((el) => el.position === position); // find the question whose Add button was clicked
          questionsArray.splice(questionIndex + 1, 0, createQuestionInOriginalForm(newQuestion)); // add the question immediately after it
        } else {
          questionsArray.splice(0, 0, createQuestionInOriginalForm(newQuestion)); // position 0 is used for the case that an ambito Add button was clicked
        }
        break;
      case "updatingTitle":
        element.question = newTitle;
        break;
      case "updatingTooltip":
        element.tooltip = updatedTooltip;
        break;
      case "removingQuestion":
        questionIndex = questionsArray.findIndex((el) => el.position === position);
        questionsArray.splice(questionIndex, 1); // position starts from one, that is why I pass position - 1
        // update the position property for the rest of the questions, probably immediately after the SWITCH method
        break;
      default:
    }
  };

  const createQuestionInOriginalForm = (newQuestion) => {
    const questionToAdd = {};

    questionToAdd.id = null;
    questionToAdd.position = newQuestion.position;
    questionToAdd.question = newQuestion.title;
    questionToAdd.tooltip = null;
    questionToAdd.displayId = newQuestion.displayId;
    questionToAdd.supervisedEntity = null;
    questionToAdd.notSupervisedEntity = null;
    questionToAdd.headCompany = null;
    questionToAdd.operativeCompany = null;
    questionToAdd.foreign = null;
    questionToAdd.italy = null;
    questionToAdd.driverCompletezza = 0;
    questionToAdd.driverAdeguatezza = 0;
    questionToAdd.driverFunzionalita = 0;
    questionToAdd.driverAffidabilita = 0;
    questionToAdd.poor = 0;
    questionToAdd.good = 0;
    questionToAdd.unsatisfactory = 0;
    questionToAdd.templateQualitativeQuestionControlFunctionOperationalScopes = [];
    questionToAdd.isQualitative = newQuestion.isQualitative;

    return questionToAdd;
  }

  // CFOS: Control Function Operational Scope
  const createCFOSinOriginalForm = function (cfId, osId) {
    const selectedContFunction = allControlFunctions.filter(cf => cf.id === cfId).map(conFun => {
      return {
        id: conFun.id,
        name: conFun.name,
        active: conFun.active
      }
    })[0];
    const selectedOpScope = allControlFunctions.filter(cf => cf.id === cfId)[0].operationalScopes.filter(os => os.id === osId)[0];

    const newCFOS = {
      controlFunction: selectedContFunction,
      operationalScope: selectedOpScope
    }

    return newCFOS;
  }

  const changeMainAttributeHandler = function (index, attrName, updatedValue) {
    const newData = [...finalData];
    newData[index].mainAttributes.find((attr) => attr.name === attrName).value = updatedValue;

    // remove red highlight of cell
    const invalidAttrs = newData[index].mainAttributes.filter(attr => !attr.disabled && attr.value === null);
    if (invalidAttrs.length === 0) {
      newData[index].invalidInputs.mainAttributeIsUndefined = false;
    }

    const record = newData[index];
    const tempDataArray = [...originalData];

    const updates = {
      mainAttribute: { name: attrName, value: updatedValue },
    }
    updateOriginalData(record, tempDataArray, "updateMainAttribute", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const changeQntAttrDriverHandler = function (index, driverName, updatedValue) {
    const newData = [...finalData];
    const drivers = ["poor", "unsatisfactory", "good"];
    newData[index][driverName] = updatedValue;
    const kpisValid = drivers.every(d => /^(?:\d+|\d+\.\d+)$/.test(newData[index][d]));
    newData[index].invalidInputs.qntAmbitoHasNoKpis = !kpisValid;
    newData[index].hasValidChildren = kpisValid;

    let requisitoId;
    let principioId;

    for (let i = index; i < newData.length; i--) {
      const el = newData[i];

      if (requisitoId && principioId) {
        break;
      }

      if (!requisitoId && el.type === "requisito") {
        requisitoId = el.id;
      }

      if (!principioId && el.type === "principio") {
        principioId = el.id;
      }

    }

    const record = { ...newData[index], ambitoId: newData[index].id, principioId, requisitoId };

    const tempDataArray = [...originalData];

    const updates = {
      supervisedEntity: undefined,
      driver: { name: driverName, value: updatedValue },
      cfosIds: undefined,
      newQuestion: undefined,
      newTitle: undefined
    }
    updateOriginalData(record, tempDataArray, "changeQntDriver", updates);
    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const changeAttrDriverHandler = function (index, driverName, updatedValue) {
    const newData = [...finalData];
    newData[index].attributesDrivers.find((driver) => driver.name === driverName).value = updatedValue;

    // remove red highlight of cell
    if (updatedValue === 1) {
      newData[index].invalidInputs.allAttrDriversAreUnckecked = false;
    } else {
      if (!attrDriversAreValid(newData[index].attributesDrivers)) {
        newData[index].invalidInputs.allAttrDriversAreUnckecked = true;
      }
    }
    const record = newData[index];
    const tempDataArray = [...originalData];

    const updates = {
      supervisedEntity: undefined,
      driver: { name: driverName, value: updatedValue },
      cfosIds: undefined,
      newQuestion: undefined,
      newTitle: undefined
    }
    updateOriginalData(record, tempDataArray, "changeDriver", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  };

  const tickingOpScopeHandler = (index, type, cfId, osId, isQualitative) => {
    let newData = [...finalData];
    newData[index].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
    let ambitoIdx;
    let principioId;
    let requisitoId;
    const record = newData[index];

    if (record.type === "ambito") {
      ambitoIdx = index;
    }

    if (!isQualitative) {
      for (let i = index; i >= 0; i--) {
        const element = newData[i];

        if (principioId && requisitoId && ambitoIdx) {
          break;
        }

        if (!ambitoIdx && element.type === "ambito") {
          ambitoIdx = i;
        }

        if (!requisitoId && element.type === "requisito") {
          requisitoId = element.id;
          newData[i].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
        }

        if (!principioId && element.type === "principio") {
          principioId = element.id;
          newData[i].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
        }
      }

      if (record.type === "ambito" || !record.type) {
        newData[ambitoIdx].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;

        for (let i = ambitoIdx + 1; i < newData.length; i++) {
          const el = newData[i];
          if (el.type) {
            break;
          } else {
            el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
            el.invalidInputs.allOpAreasAreUnchecked = false;
          }
        }
      }
    } else {
      // remove red highlight of cell
      if (!record.type) {
        newData[index].invalidInputs.allOpAreasAreUnchecked = false;
      }
      if (record.type) {
        record.hasValidChildren = true;
      }

      if (record.type !== "principio") { // including the case where the selected element is a question, thus: undefined !== "principio", since questions don't have the "type" attribute
        let hierarchyThreshold = 0; // question hierarchy level (lowest hierarchy)
        if (record.type) {
          hierarchyThreshold = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element. The hierarchyArray is initialized at the top of the file.
        }

        for (let i = index - 1; i >= 0; i--) {
          const el = finalData[i];
          if (el.type) {
            let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
            if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element, thus we stop the iteration
              el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
              break;
            }
            else if (currentElementHierarchyLevel > hierarchyThreshold) {
              hierarchyThreshold++;
              el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
              if (!el.type) {
                el.invalidInputs.allOpAreasAreUnchecked = false;
              }
            }
          }
        }
      }

      // if clicked element was not a question, we have to update all the children elements
      if (record.type) {
        const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element
        for (let i = index + 1; i < newData.length; i++) {
          const el = newData[i];
          if (el.type) {
            if (hierarchyArray.findIndex(item => item === el.type) < hierarchyLevelOfSelectedElement) {
              el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
            } else {
              break;
            }
          } else {
            // it is a question object, thus we immediately set the op. scope to true
            el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
            el.invalidInputs.allOpAreasAreUnchecked = false;
          }
        }
      }
    }


    // To add CFOS record: create the record in original form and just push it to the end of the CFOS list

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: { cfId, osId },
      newQuestion: undefined,
      newTitle: undefined
    }

    const tempDataArray = [...originalData];
    if (!record.type && isQualitative) {
      updateOriginalData(record, tempDataArray, "checkingOpScope", updates) // clicked item is a question
    } else if (isQualitative === false) {
      updateOriginalData({ ...record, conFuncOpScopes: createCFOSinOriginalForm(cfId, osId), ambitoId: newData[ambitoIdx].id, requisitoId, principioId }, tempDataArray, "checkingQntOpScope", updates);
    } else {
      higherHierarchyElementsHandler(record, tempDataArray, "checkingOpScope", updates); // clicked item is an ambito/requisito/principio
    }

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const untickingOpScopeHandler = (index, type, cfId, osId, isQualitative) => {
    let newData = [...finalData];
    const record = newData[index];
    let principioId;
    let requisitoId;
    let ambitoElement
    record.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;

    if (!isQualitative) {
      for (let i = index; i >= 0; i--) {
        const element = newData[i];

        if (principioId && requisitoId) {
          break;
        }

        if (!requisitoId && element.type === "requisito") {
          requisitoId = element.id;
          newData[i].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
        }

        if (!principioId && element.type === "principio") {
          principioId = element.id;
          newData[i].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
        }
      }
      if (!record.type) {
        ambitoElement = newData.findIndex(el => el.id === record.ambitoId && el.type === "ambito");

        newData[ambitoElement].conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;

        for (let i = ambitoElement + 1; i < newData.length; i++) {
          const el = newData[i];
          if (el.type) {
            break;
          } else {
            el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
          }
        }
      } else {
        ambitoElement = index;
      }
    }

    if (!record.type) {
      if (!enabledOpScopeFound(record.conFuncOpScopes)) {
        record.invalidInputs.allOpAreasAreUnchecked = true;
      }

      for (let i = index - 1; i >= 0; i--) {
        const el = newData[i];
        if (el.type) {
          el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
        }
        if (el.type === "principio") {
          break;
        }
      }

    } else {
      let invalidQuestionFound = false; // a question that all of its opScopes are unchecked
      const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === type); //defining the hierarchy level of the selected element
      for (let i = index + 1; i < newData.length; i++) {
        const el = newData[i];
        if (el.type) {
          if (hierarchyArray.findIndex(item => item === el.type) < hierarchyLevelOfSelectedElement) {
            el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
          } else break;
        } else {
          // it is a question object, thus we immediately set the op. scope to false
          el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
          if (!enabledOpScopeFound(el.conFuncOpScopes)) {
            el.invalidInputs.allOpAreasAreUnchecked = true;
            invalidQuestionFound = true;
          }
        }
      }
      newData[index].hasValidChildren = invalidQuestionFound ? false : true;

      // Explanation for the following logic: We search for the end of the current principio (or the end of data). 
      // Once found, we use its index as an ending point for our operations
      let endingPoint = 0;
      for (let i = index; i < newData.length; i++) {
        const el = newData[i];
        if (i === newData.length - 1) { // if this is the last element of the template
          endingPoint = newData.length;
          break;
        }
        if (el.type === "principio") {
          endingPoint = i;
          break;
        }
        if (el.type) {
          el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
        }
      }
      // We set the opScope of all elements that are not questions to false
      if (record.type !== "principio") {
        for (let i = index - 1; i >= 0; i--) {
          const el = newData[i];
          if (el.type) {
            el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = false;
          }
          if (el.type === "principio") {
            break;
          }
        }
      }

      // In the following iteration, we set the non-question elements' opScope based on the questions that are "ticked", 
      // that is why we set these element's opScope to false in the previous step
      // Basically, if the opScope of a question is "ticked", we also enable the opScopes for all the elements that this question belongs to, up to the question's principio
      // All these operations are based on the logic of the initial useEffect hook, where all elements' opScopes are determined by the questions checked throughout the structure
      for (let i = endingPoint - 1; i >= 0; i--) {
        const arrayEl = newData[i];
        const selectedOpScope = arrayEl.conFuncOpScopes[cfId].find(os => os.id === osId);
        if (!arrayEl.type) {
          if (selectedOpScope.enabled === true) {
            let hierarchyThreshold = 0;
            for (let j = i - 1; j >= 0; j--) {
              const el = newData[j];
              if (el.type) {
                let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
                if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) { // it is the highest hierarchy element, thus we stop the iteration
                  el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
                  break;
                }
                else if (currentElementHierarchyLevel > hierarchyThreshold) {
                  el.conFuncOpScopes[cfId].find(os => os.id === osId).enabled = true;
                  hierarchyThreshold++;
                }
              }
            }
          }
        } else if (arrayEl.type === "principio") {
          break;
        }
      }
    }


    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: { cfId, osId },
      newQuestion: undefined,
      newTitle: undefined
    }

    const tempDataArray = [...originalData];
    if (!record.type && isQualitative) {
      // if (record.questionType === "qualitative") {
      updateOriginalData(record, tempDataArray, "uncheckingOpScope", updates) // clicked item is a question
      // } 
      // else {
      //   for (let i = index; i >= 0; i--) {
      //     if (newData[i].type === "ambito") { // clicked item is a QUANTITATIVE question, thus we pass the ambito to untick all the questions in that ambito
      //       higherHierarchyElementsHandler(newData[i], tempDataArray, "uncheckingOpScope", updates); 
      //       break;
      //     }
      //   }
      // }
    } else if (!isQualitative) {
      updateOriginalData({ ...record, ambitoId: newData[ambitoElement].id, requisitoId, principioId }, tempDataArray, "uncheckingQntOpScope", updates);
    } else {
      higherHierarchyElementsHandler(record, tempDataArray, "uncheckingOpScope", updates); // clicked item is an ambito/requisito/principio
    }

    setOriginalData(tempDataArray);
    setFinalData(newData);
  };

  const addQuestionHandler = (index) => {
    let newData = [...finalData];

    const conFuncOpScopes = {};
    for (let cf of allControlFunctions) {
      conFuncOpScopes[cf.id] = [...allControlFunctions.filter(conF => conF.id === cf.id)[0].operationalScopes.map(el => {
        return {
          id: el.id,
          name: el.name,
          enabled: false
        }
      })];
    }

    const mainAttributes = [
      {
        value: null,
        name: "supervisedEntity",
        label: "Supervised Entity",
        shortName: "SE"
      },
      {
        value: null,
        name: "notSupervisedEntity",
        label: "Not Supervised Entity",
        shortName: "N_SE"
      },
      {
        value: null,
        name: "isHeadCompany",
        label: "Holding",
        shortName: "HOLD"
      },
      {
        value: null,
        name: "isOperativeCompany",
        label: "Operating Legal Entity",
        shortName: "OP_COMP"
      },
      {
        value: null,
        name: "isForeign",
        label: "Other Region",
        shortName: "OTH_REG"
      },
      {
        value: null,
        name: "isItaly",
        label: "Region Italy",
        shortName: "REG_ITA"
      },
    ]

    const attributesDrivers = [
      {
        value: 0,
        name: "Completeness"
      },
      {
        value: 0,
        name: "Accuracy"
      },
      {
        value: 0,
        name: "Effectiveness"
      },
      {
        value: 0,
        name: "Reliability"
      }
    ]

    let fatQualId;
    let principioId;
    let requisitoId;
    let ambitoId;
    let isQualitative;

    let isInsideInitialPrincipio = true;

    let newDisplayId = 0;
    let newId = 0;

    let hierarchyThreshold = 0;
    if (newData[index].type === "ambito") {
      ambitoId = newData[index].id;
      hierarchyThreshold = 1;
    } else {
      hierarchyThreshold = 0; // hierarchyArray.findIndex(item => item === "question");
      if (!newData[index].type) {
        newDisplayId = newData[index].displayId + 1;
      }
    }

    for (let i = index - 1; i >= 0; i--) {
      const el = newData[i];
      if (el.type) {
        let currentElementHierarchyLevel = hierarchyArray.findIndex(item => item === el.type);
        if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "fatQual")) { // it is the highest hierarchy element, thus we stop the iteration
          fatQualId = el.id;
          el.span += 1; // increase the "span" property value of the fatQual element since a question was added
          break;
        }
        else if (currentElementHierarchyLevel > hierarchyThreshold) { // I will not be receiving empty "ambito" elements so I don't need to check for that (BUT what if a user deletes all questions from an ambito?)
          hierarchyThreshold++;
          if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "principio")) {
            principioId = el.id;
            isInsideInitialPrincipio = false;
          }
          else if (currentElementHierarchyLevel === hierarchyArray.findIndex(item => item === "requisito")) {
            requisitoId = el.id;
          }
          else {
            ambitoId = el.id;
          }
        } else continue;
      } else {
        if (isInsideInitialPrincipio) {
          if (newDisplayId <= el.displayId) {
            newDisplayId = el.displayId + 1;
          }
        }
      }
    }

    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (el.type) {
        if (el.type === "principio") {
          break;
        } else {
          continue;
        }
      } else {
        if (newDisplayId <= el.displayId) {
          newDisplayId = el.displayId + 1;
        };
      }
    }

    for (let i = ambitoId + 1; i <= newData.length; i++) {
      const element = newData[i];

      if (element.type) {
        break;
      }





    }

    const invalidInputs = {
      mainAttributeIsUndefined: false,
      allAttrDriversAreUnckecked: false,
      questionTitleIsEmpty: false,
      allOpAreasAreUnchecked: false
    }

    const newQuestion = {
      conFuncOpScopes: conFuncOpScopes,
      position: newData[index].position ? newData[index].position + 1 : 1, // if the clicked element is an ambito, since it has no position prop in the flattened array, then the new question will have pos 1)
      title: "",
      mainAttributes,
      attributesDrivers: attributesDrivers,
      fatQualId,
      principioId,
      requisitoId,
      ambitoId,
      tooltip: null,
      displayId: newDisplayId,
      invalidInputs: invalidInputs,
      isQualitative: true
      // id: null,
    }

    newData.splice(index + 1, 0, newQuestion);

    // the code below is used to update the position of the questions in the same ambito
    for (let i = index + 2; i < newData.length; i++) { // index = element that was clicked, index + 1 = the added question, so we want to make changes from index + 2 and on
      const el = newData[i];
      if (!el.type) { // question elements don't have a type property
        el.position += 1;
      } else {
        break;
      }
    }

    const record = newData[index].type ? { ...newQuestion } : newData[index];
    if (newData[index].type) { // if the clicked element was an ambito which has a type prop
      record.position = 0; // position = 0 will be interpreted by updateOriginalData() that the clicked element was an ambito
    }

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: undefined,
      newQuestion: newQuestion,
      newTitle: undefined
    }

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "addingQuestion", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const addAmbitoHandler = (index) => {
    let newData = [...finalData];

    const conFuncOpScopes = {};
    for (let cf of allControlFunctions) {
      conFuncOpScopes[cf.id] = [...allControlFunctions.filter(conF => conF.id === cf.id)[0].operationalScopes.map(el => {
        return {
          id: el.id,
          name: el.name,
          enabled: false
        }
      })];
    }

    const attributesDrivers = [
      {
        value: 0,
        name: "Poor",
        disabled: true,
      },
      {
        value: 0,
        name: "Good",
        disabled: true,
      },
      {
        value: 0,
        name: "Unsatisfactory",
        disabled: true,
      }
    ]

    let fatQualId;
    let principioId;
    let requisitoId = newData[index].id;

    let hierarchyThreshold = 0;

    let newAmbitoDisplayId = 1;

    for (let i = index - 1; i >= 0; i--) {
      const ele = newData[i];

      if (principioId && fatQualId) {
        break;
      }

      if (!principioId && ele.type === "principio") {
        hierarchyThreshold = 2;
        principioId = ele.id;
      }

      if (!fatQualId && ele.type === "fatQual") {
        fatQualId = ele.id;
      }
    }

    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (el.type) {
        if (el.type === "ambito" && el.position) {
          newAmbitoDisplayId = Math.max(newAmbitoDisplayId, el.position + 1);
        } else if (el.type === "requisito") {
          break;
        } else {
          continue;
        }
      }
    }

    const invalidInputs = {
      mainAttributeIsUndefined: false,
      allAttrDriversAreUnckecked: false,
      questionTitleIsEmpty: false,
      allOpAreasAreUnchecked: false,
    }

    const newQuestion = {
      conFuncOpScopes: conFuncOpScopes,
      title: "",
      attributesDrivers: attributesDrivers,
      fatQualId,
      ambitoId: null,
      principioId,
      requisitoId,
      tooltip: null,
      active: true,
      isQualitative: false,
      invalidInputs: { ...invalidInputs, questionIsDuplicate: false },
      templateQuantitativeQuestionControlFunctionOperationalScopes: []
    }

    const newAmbito = {
      id: null,
      position: newAmbitoDisplayId,
      conFuncOpScopes: conFuncOpScopes,
      title: "",
      tooltip: null,
      type: "ambito",
      isHidden: false,
      isCollapsed: false,
      hasValidChildren: true,
      isDeletable: true,
      active: true,
      invalidInputs: { ambitoTitleIsEmpty: false, ambitoTitleIsDuplicate: false, qntAmbitoHasInvalidQuestionsLength: false, qntAmbitoHasNoKpis: false },
      isEmpty: true,
      isQualitative: false,
      poor: undefined,
      unsatisfactory: undefined,
      good: undefined,
      templateQualitativeQuestions: [],
      templateQuantitativeQuestions: [{ ...newQuestion, position: 1, displayId: 1 }, { ...newQuestion, position: 2, displayId: 2 }]
    }

    newData.splice(index + 1, 0, newAmbito);
    newData.splice(index + 2, 0, { ...newQuestion, questionId: null, isEmpty: true, position: 1, displayId: 1 });
    newData.splice(index + 3, 0, { ...newQuestion, questionId: null + 1, isEmpty: true, position: 2, displayId: 2 });

    // the code below is used to update the position of the questions in the same ambito
    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (!el.type) {
        el.position += 1;
      } else {
        break;
      }
    }

    const record = { ...newAmbito, requisitoId: newData[index].id, principioId };
    const newAmbitoObj = {
      id: null,
      title: '',
      position: newAmbitoDisplayId || 1,
      isQualitative: false,
      isDeletable: true,
      active: true,
      templateQualitativeQuestions: [],
      templateQuantitativeQuestions: [
        {
          id: null,
          question: '',
          manualScore: 0,
          isQualitative: false,
          templateCosoAmbitoId: null,
          templateQuantitativeQuestionControlFunctionOperationalScopes: [],
          position: 1,
          displayId: 1,
        },
        {
          id: null,
          question: '',
          manualScore: 0,
          isQualitative: false,
          templateCosoAmbitoId: null,
          templateQuantitativeQuestionControlFunctionOperationalScopes: [],
          position: 2,
          displayId: 2,
        }
      ],
      tooltip: null,
      poor: undefined,
      unsatisfactory: undefined,
      good: undefined

    }
    if (newData[index].type) { // if the clicked element was an ambito which has a type prop
      record.position = 0; // position = 0 will be interpreted by updateOriginalData() that the clicked element was an ambito
    }

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: undefined,
      newAmbito: newAmbitoObj,
      newTitle: undefined,
    }

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "addingAmbito", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const toggleAmbitoHandler = (index, isActive) => {
    let newData = [...finalData];

    let requisitoId;
    let principioId;

    for (let i = index; i < newData.length; i--) {
      const el = newData[i];

      if (requisitoId && principioId) {
        break;
      }

      if (!requisitoId && el.type === "requisito") {
        requisitoId = el.id;
      }

      if (!principioId && el.type === "principio") {
        principioId = el.id;
      }

    }
    const record = { ...newData[index], active: isActive, ambitoId: newData[index].id, principioId, requisitoId };

    if (!isActive) {
      newData[index].invalidInputs.qntAmbitoHasInvalidQuestionsLength = false;
      newData[index].qntAmbitoHasNoKpis = false;
    }

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "togglingAmbito", {});

    newData.splice(index, 1, record);

    for (let idx = index + 1; index <= newData.length; idx++) {
      const el = newData[idx];
      if (!el.type) {
        el.active = isActive;

        if (!el.active) {
          el.invalidInputs.allOpAreasAreUnchecked = false;
        }
      } else {
        break;
      }
    }

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const removeQuestionHandler = (index) => {
    let newData = [...finalData];
    let questionToBeRemoved = newData[index];
    newData.splice(index, 1);

    // reducing fattoreQualificante length by 1
    for (let i = index - 1; i >= 0; i--) {
      const el = newData[i];
      if (el.type && el.type === "fatQual") {
        el.span -= 1;
        break;
      }
    }

    for (let i = index; i >= 0; i--) {
      const el = newData[i];

      if (el.type && el.type === "ambito") {
        el.templateQuantitativeQuestions = el.templateQuantitativeQuestions.filter(q => q.id !== newData[index].questionId);
        el.invalidInputs.qntAmbitoHasInvalidQuestionsLength = el.templateQuantitativeQuestions.length !== 2;
        break;
      }
    }

    // reducing the position property of all the questions that followed the deleted one by 1 (in the same ambito)
    for (let i = index; i < newData.length; i++) {
      const el = newData[i];
      if (!el.type) {
        el.position -= 1;
      } else {
        break;
      }
    }

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: undefined,
      newQuestion: undefined,
      newTitle: undefined
    }

    const tempDataArray = [...originalData];
    updateOriginalData(questionToBeRemoved, tempDataArray, "removingQuestion", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const removeAmbitoHandler = (index) => {
    let newData = [...finalData];
    let ambitiToBeRemoved = newData[index];
    let endIdx = index;
    let principioId;
    let requisitoId;

    for (let i = index - 1; i >= 0; i--) {
      const el = newData[i];

      if (requisitoId && principioId) {
        break;
      }

      if (!requisitoId && el.type === "requisito") {
        requisitoId = el.id;
      }

      if (!principioId && el.type === "principio") {
        principioId = el.id;
      }
    }

    for (let i = index + 1; i < newData.length; i++) {
      const element = newData[i];

      if (element.type) {
        break;
      } else {
        endIdx = i;
      }
    }

    newData.splice(index, endIdx - index + 1);

    // reducing the position property of all the ambitos that followed the deleted one by 1 (in the same requisito)
    for (let i = index; i < newData.length; i++) {
      const el = newData[i];
      if (el.type === "ambito") {
        el.position -= 1;
      } else {
        break;
      }
    }

    const record = { ...ambitiToBeRemoved, ambitoId: ambitiToBeRemoved.id, requisitoId, principioId };

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "removingAmbito", {});

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const updateQuestionTitleHandler = (index, title) => {
    let newData = [...finalData];
    newData[index].title = title;

    // remove red highlight of cell
    if (questionTitleIsValid(newData[index].title)) {
      newData[index].invalidInputs.questionTitleIsEmpty = false;
    } else {
      newData[index].invalidInputs.questionTitleIsEmpty = true;
    }

    const record = newData[index];

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: undefined,
      newQuestion: undefined,
      newTitle: title
    }

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "updatingTitle", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);
  };

  const updateAmbitoTitleHandler = (index, title) => {
    let newData = [...finalData];
    newData[index].title = title;

    // remove red highlight of cell
    if (questionTitleIsValid(newData[index].title)) {
      newData[index].invalidInputs.ambitoTitleIsEmpty = false;
    } else {
      newData[index].invalidInputs.ambitoTitleIsEmpty = true;
    }

    let principioId;
    let requisitoId;

    for (let i = index - 1; i >= 0; i--) {
      const ele = newData[i];

      if (requisitoId && principioId) {
        break;
      }

      if (!principioId && ele.type === "principio") {
        principioId = ele.id;
      }

      if (!requisitoId && ele.type === "requisito") {
        requisitoId = ele.id;
      }

    }

    const record = { ...newData[index], ambitoId: newData[index].id, principioId, requisitoId };

    const updates = {
      supervisedEntity: undefined,
      driver: undefined,
      cfosIds: undefined,
      newQuestion: undefined,
      newTitle: title
    }

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "updatingAmbitoTitle", updates);

    setOriginalData(tempDataArray);
    setFinalData(newData);

  }


  const collapseElement = function (index, isCollapsedUpdatedValue) {
    // clicked elements will never be questions
    let newData = [...finalData];
    newData[index].isCollapsed = isCollapsedUpdatedValue;
    const record = newData[index];
    let newIsHiddenValue = false;
    if (isCollapsedUpdatedValue === true) {
      newIsHiddenValue = true;
    }

    let invalidInputFound = false;
    // DESCRIPTION of all the variables used below: (hierarchy is the order of the "layers", from question to fatQual)
    // 1. hierarchyLevelOfSelectedElement: The hierarchy of the element that was clicked
    // 2. currentCollapsedElementHierarchy: The hierachy of the current element that was detected to be collapsed while iterating through the newData array
    // 3. elHierarchy: the hierarchy of the current iteration element
    // 4. isInsideCollapsedElement: a boolean that checks if we are inside a collapsed element

    let currentCollapsedElementHierarchy = 0;
    let isInsideCollapsedElement = false;
    const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === record.type); //defining the hierarchy level of the selected element
    for (let i = index + 1; i < newData.length; i++) {
      let el = newData[i];
      if (el.type) {
        let elHierarchy = hierarchyArray.findIndex(type => type === el.type);
        if (elHierarchy < hierarchyLevelOfSelectedElement) {
          if (el.isCollapsed && !isInsideCollapsedElement) {
            isInsideCollapsedElement = true;
            currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
            el.isHidden = newIsHiddenValue;
            if (isCollapsedUpdatedValue === false && !el.isHidden) {
              determineValidityOfElement(i);
            }
            if (isCollapsedUpdatedValue === true && !invalidInputFound) {
              if (!el.hasValidChildren) {
                invalidInputFound = true;
              }
            }
            // if (!invalidInputFound) {
            //   if (isCollapsedUpdatedValue === true) {
            //     if (!el.hasValidChildren) {
            //       invalidInputFound = true;
            //     }
            //   } else {
            //     determineValidityOfElement(i);
            //   }
            // }
            continue;
          }
          if (isInsideCollapsedElement) {
            if (elHierarchy >= currentCollapsedElementHierarchy) {
              if (el.isCollapsed) {
                currentCollapsedElementHierarchy = hierarchyArray.findIndex(type => type === el.type);
                if (isCollapsedUpdatedValue === true && !invalidInputFound) {
                  if (!el.hasValidChildren) {
                    invalidInputFound = true;
                  }
                }
              } else {
                isInsideCollapsedElement = false;
              }
              el.isHidden = newIsHiddenValue;
            }
          } else {
            el.isHidden = newIsHiddenValue;
          }
        } else break;
      } else {
        // element is a question
        if (!isInsideCollapsedElement) {
          el.isHidden = newIsHiddenValue;
          if (isCollapsedUpdatedValue === true && !invalidInputFound) {
            for (const value of Object.values(el.invalidInputs)) {
              if (value === true) {
                invalidInputFound = true;
                break;
              }
            }
          }
        }
      }
    }
    newData[index].hasValidChildren = invalidInputFound ? false : true;

    setFinalData(newData);
  }

  const updateTooltipHandler = function (index, updatedTooltip) {
    let newData = [...finalData];
    newData[index].tooltip = updatedTooltip;
    const record = newData[index];

    const updates = {
      updatedTooltip
    };

    const tempDataArray = [...originalData];
    updateOriginalData(record, tempDataArray, "updatingTooltip", updates);

    if (!record.type) {
      updateOriginalData(record, tempDataArray, "updatingTooltip", updates) // clicked item is a question
    } else {
      higherHierarchyElementsHandler(record, tempDataArray, "updatingTooltip", updates); // clicked item is an ambito/requisito/principio
    }

    setOriginalData(tempDataArray);
    setFinalData(newData);
  }

  const attributeTabIsValidHandler = function (cfId) {
    if (attributesValidityErrors().length === 0) { // if errorsList is empty
      setAreAttributesShown(false);
      setSelectedControlFunctionId(cfId);
      setSelectedOpScopes(allControlFunctions.filter(cf => cf.id === cfId)[0].operationalScopes.map(el => ({
        ...el,
        infoIconIsVisible: false
      })));
    }

    // checkValidityOfElementsChildren();
  }

  const controlFunctionTabsAreValidHandler = function () {
    if (controlFunctionsValidityErrors().length === 0) { // if errorsList is empty
      setAreAttributesShown(true)
      setSelectedControlFunctionId(0);
    }
    // checkValidityOfElementsChildren();
  }


  const attrDriversAreValid = function (attributesDrivers) {
    for (const driver of attributesDrivers) {
      if (driver.value === 1) {
        return true;
      }
    }
    return false;
  }

  const questionTitleIsValid = function (title) {
    if (!title || (title && title.replace(/\s/g, "").length === 0)) {
      return false;
    }
    return true;
  }

  const enabledOpScopeFound = function (conFuncOpScopes) {
    for (const cf of allControlFunctions) {
      const filteredCF = conFuncOpScopes[cf.id].filter(os => os.enabled === true);
      if (filteredCF.length > 0) {
        return true;
      }
    }
    return false;
  }

  const attributesValidityErrors = function () {
    // TODO: more checks need to be added
    const errorsList = [];

    let emptyTitleFound = false;
    let emptyAmbitoTitleFound = false;
    let uncheckedAttributesErrorFound = false;
    let mainAttributesErrorFound = false;
    let duplicateAmbitoTitleFound = false;
    let duplicateQuestionTitleFound = false;
    let invalidAmbitoQuestionsLengthFound = false;
    let invalidAmbitoKpisFound = false;

    let newData = [...finalData];

    for (const el of newData) {
      if (el.type === "ambito" && el.isEmpty) {
        if (!el.title) {
          el.invalidInputs.ambitoTitleIsEmpty = true;
          if (!emptyAmbitoTitleFound) {
            errorsList.push("Each Ambito title must contain text");
            emptyAmbitoTitleFound = true;
          }
        }
      }

      if (el.type === "ambito" && el.active && !el.isQualitative) {
        const isValid = (v) => /^(?:\d+|\d+\.\d+)$/.test(v);
        if (!isValid(el.good) || !isValid(el.unsatisfactory) || !isValid(el.poor)) {
          el.invalidInputs.qntAmbitoHasNoKpis = true;
          if (!invalidAmbitoKpisFound) {
            errorsList.push("Each quantitative ambito must have valid KPIs");
            invalidAmbitoKpisFound = true;
          }
        } else {
          el.invalidInputs.qntAmbitoHasNoKpis = false;
        }

      }

      if (el.type === "ambito" && el.active && !el.isQualitative) {
        if (el.templateQuantitativeQuestions?.length !== 2) {
          el.invalidInputs.qntAmbitoHasInvalidQuestionsLength = true;

          if (!invalidAmbitoQuestionsLengthFound) {
            invalidAmbitoQuestionsLengthFound = true;
            errorsList.push("Each quantitative Ambito must have two quantitative questions");
          }
        } else {
          el.invalidInputs.qntAmbitoHasInvalidQuestionsLength = false;
        }
      }

      if (el.type === "ambito" && !el.isQualitative && el.isEmpty) {
        const invalidElIdx = newData.findIndex(item => item.id !== el.id && !item.isQualitative && item.type === "ambito" && item.title === el.title);

        if (invalidElIdx < 0) {
          el.invalidInputs.ambitoTitleIsDuplicate = false;
        } else {
          el.invalidInputs.ambitoTitleIsDuplicate = true;

          if (!duplicateAmbitoTitleFound) {
            duplicateAmbitoTitleFound = true;
            errorsList.push("Each quantitative Ambito title must be unique");
          }
        }

      }

      if (!el.type && !el.isQualitative) {
        const invalidElIdx = newData.findIndex(item => item.questionId !== el.questionId && !item.isQualitative && !item.type && item.title === el.title);

        if (invalidElIdx < 0) {
          el.invalidInputs.questionIsDuplicate = false;
        } else {
          el.invalidInputs.questionIsDuplicate = true;

          if (!duplicateQuestionTitleFound) {
            duplicateQuestionTitleFound = true;
            errorsList.push("Each quantitative Question title must be unique");
          }
        }
      }

      if (!el.type) {
        // Title check
        if (!questionTitleIsValid(el.title)) {
          el.invalidInputs.questionTitleIsEmpty = true;
          if (!emptyTitleFound) {
            errorsList.push("Each question title must contain text");
            emptyTitleFound = true;
          }
        }

        // Attr. Drivers check
        if (el.isQualitative && !attrDriversAreValid(el.attributesDrivers)) {
          el.invalidInputs.allAttrDriversAreUnckecked = true;
          if (!uncheckedAttributesErrorFound) {
            errorsList.push("For each question there must be at least 1 Flag for ICS Dimensions (Completeness, Accuracy, Effectiveness, Reliability)")
            uncheckedAttributesErrorFound = true;
          }
        }

        if (el.mainAttributes) {
          for (const attr of el.mainAttributes) {
            if (attr.value === null) {
              el.invalidInputs.mainAttributeIsUndefined = true;
              if (!mainAttributesErrorFound) {
                errorsList.push("A selection must be made for all main attributes (Yes or No)")
                mainAttributesErrorFound = true;
              }
            }
          }
        }

      }
    }

    setFinalData(newData);

    if (errorsList.length > 0) {
      modalDataHandler(
        "The following validity requirements are not met:",
        errorsList,
        'error',
        modalCloseHandler);
    }

    return errorsList;
  }

  const controlFunctionsValidityErrors = function () {
    const errorsList = [];
    let newData = [...finalData];
    let opAreaErrorFound = false;

    for (const el of newData) {

      if (!el.type) {
        if (!el.isQualitative && !el?.active) {
          el.invalidInputs.allOpAreasAreUnchecked = false;
          continue;
        }

        if (!enabledOpScopeFound(el.conFuncOpScopes)) {
          el.invalidInputs.allOpAreasAreUnchecked = true;
          if (!opAreaErrorFound) {
            errorsList.push("Each question must have at least one Operational Area enabled for at least one Control Function");
            opAreaErrorFound = true;
          }
        }
      }
    }

    setFinalData(newData);

    if (errorsList.length > 0) {
      modalDataHandler(
        "The following validity requirements are not met:",
        errorsList,
        'error',
        modalCloseHandler);
    }

    return errorsList;
  }

  const determineValidityOfElement = function (index) {
    // this function receives a non-question element and check if there are any invalid questions
    const newData = [...finalData];
    const record = newData[index];

    const hierarchyLevelOfSelectedElement = hierarchyArray.findIndex(item => item === record.type);

    for (let i = index + 1; i < newData.length; i++) {
      const el = newData[i];
      if (el.type && !(hierarchyArray.findIndex(item => item === el.type) < hierarchyLevelOfSelectedElement))
        break;
      if (!el.type) {
        for (const value of Object.values(el.invalidInputs)) {
          if (value === true) {
            newData[index].hasValidChildren = false;
            return;
          }
        }
      }
    }
    newData[index].hasValidChildren = true;
  }

  const checkValidityOfElementsChildren = function () {
    const newData = [...finalData];
    // isws xreiastei na kanw anazhthsh anapoda (descending order). Pithanotata na exw xrhsimopoihsei paromoia logikh kai allou. Psaxnw gia i--. Isws sthn arxh autoy tou arxeioy
    let invalidInputFound = false;
    let currentPrincipiPos = 1;
    for (let i = 0; i < newData.length; i++) {
      let el = newData[i];
      if (el.type && el.type === "principio") {
        currentPrincipiPos = i;
        invalidInputFound = false;
      } else {
        if (!invalidInputFound) {
          if (!el.type) {
            for (const value of Object.values(el.invalidInputs)) {
              if (value === true) {
                invalidInputFound = true;
                newData[currentPrincipiPos].hasValidChildren = false;
                break;
              }
            }
          }
        }
      }
    }
  }

  const dataValidationHandler = () => {
    const validityErrors = attributesValidityErrors().concat(controlFunctionsValidityErrors());
    if (validityErrors.length === 0) {
      modalDataHandler(
        "Update Framework",
        "Save changes?",
        'confirmation',
        saveTemplateHandler
      )
    } else {
      // checkValidityOfElementsChildren();
      modalDataHandler(
        "The following validity requirements are not met:",
        validityErrors,
        'error',
        modalCloseHandler);
    }
  }

  const saveTemplateHandler = () => {
    setIsLoadingButtons(true);
    const templateServiceApi = new TemplateServiceApi();
    console.log("originalData to be saved: ", originalData);
    templateServiceApi.updateTemplate(originalData, (error, data) => { // (id, callback)
      if (!error) {
        setIsLoadingButtons(false); // this setter is not outside the if statement because if it was, when the component unmounts, we get a memory leak warning because we would 
        // be trying to update an unmounted component
        modalDataHandler("", `The questions of the Framework are saved!`, 'notification', () => history.push("/home"))
      } else {
        setIsLoadingButtons(false);
        modalDataHandler(``, "Error! The template was not saved!", 'error', () => setModalShow(false));
      }
    });
  }

  const modalDataHandler = function (title, message, modType, action) {
    setModalTitle(title);
    setModalMessage(message);
    setModalType(modType);
    setModalAction(action ? () => action : null);
    setModalShow(true);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  return {
    /* state */ error, setError,
    isLoading, setIsLoading,
    isLoadingButtons, setIsLoadingButtons,
    finalData,
    originalData, setOriginalData,
    modalShow,
    modalAction,
    modalTitle,
    modalMessage,
    modalType,
    areAttributesShown,
    allControlFunctions,
    selectedControlFunctionId,
    selectedOpScopes, setSelectedOpScopes,
    /* functions */
    initialConfiguration,
    createDataObject,
    createQuestionObject,
    updateOriginalData,
    createQuestionInOriginalForm,
    // changeSupervisedEntityHandler,
    // changeNotSupervisedEntityHandler,
    changeMainAttributeHandler,
    changeAttrDriverHandler,
    changeQntAttrDriverHandler,
    tickingOpScopeHandler,
    untickingOpScopeHandler,
    addQuestionHandler,
    addAmbitoHandler,
    toggleAmbitoHandler,
    removeQuestionHandler,
    removeAmbitoHandler,
    updateQuestionTitleHandler,
    updateAmbitoTitleHandler,
    attributeTabIsValidHandler,
    controlFunctionTabsAreValidHandler,
    dataValidationHandler,
    modalDataHandler,
    modalCloseHandler,
    collapseElement,
    updateTooltipHandler,
  }
}

export default useTemplateMonitorLogic;
